import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { SidenavService } from '@ml/core/services';
import { NotificationsService } from '@ml/notifications/services';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { QueryParams } from '@ml/shared/types/query-params';
import { NotificationType } from '@ml/notifications/types/enums';
import { Router } from '@angular/router';
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent(notificationsService, sidenavService, router) {
        this.notificationsService = notificationsService;
        this.sidenavService = sidenavService;
        this.router = router;
        this.ngUnsubscribe = new Subject();
        this.notifications$ = new BehaviorSubject(null);
    }
    NotificationsComponent.getInitQueryParams = function () {
        var queryParams = new QueryParams();
        queryParams.pageSize = 20;
        return queryParams;
    };
    NotificationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var queryParams = NotificationsComponent.getInitQueryParams();
        this.lastQueryParams$ = new BehaviorSubject(queryParams);
        this.lastQueryParams$
            .pipe(takeUntil(this.ngUnsubscribe), switchMap(function (params) { return _this.getNotifications(params); }))
            .subscribe(function (response) {
            response.next ? (_this.next = true) : (_this.next = false);
            _this.setNotifications(response);
            _this.loadingMore = false;
            _this.setReadNotifications(response.results);
        });
    };
    NotificationsComponent.prototype.onRemove = function (notification) {
        var _this = this;
        this.notificationsService
            .delete(notification.id)
            .pipe(tap(function () {
            return _this.notifications$.next(_this.notifications$.value.filter(function (_notification) { return notification.id !== _notification.id; }));
        }), tap(function () {
            // If after deleting a notification, there are less than 20 notifications, get the first page again
            if (_this.notifications$.value.length < 20) {
                _this.lastQueryParams$.next(tslib_1.__assign({}, _this.lastQueryParams$.value, { page: 1 }));
            }
        }))
            .subscribe();
    };
    NotificationsComponent.prototype.onLoadMore = function () {
        this.loadingMore = true;
        var lastQueryParams = this.lastQueryParams$.value;
        lastQueryParams.page++;
        this.lastQueryParams$.next(tslib_1.__assign({}, lastQueryParams));
    };
    NotificationsComponent.prototype.onRedirect = function (notification) {
        if (notification.type === NotificationType.TASK) {
            this.router.navigate(['tasks', notification.objectId]);
            this.sidenavService.close();
        }
        if (notification.type === NotificationType.ORDER) {
            this.router.navigate(['orders', notification.objectId]);
            this.sidenavService.close();
        }
    };
    NotificationsComponent.prototype.onClearAll = function () {
        var _this = this;
        if (this.notifications$.value.length === 0) {
            return;
        }
        this.notificationsService
            .clearAll()
            .subscribe(function () {
            return _this.lastQueryParams$.next(NotificationsComponent.getInitQueryParams());
        });
    };
    NotificationsComponent.prototype.onClose = function () {
        this.sidenavService.close();
    };
    /**
     * Call the list method from notifications service
     */
    NotificationsComponent.prototype.getNotifications = function (params) {
        return this.notificationsService
            .list(params)
            .pipe(catchError(function () { return of([]); }));
    };
    NotificationsComponent.prototype.setNotifications = function (response) {
        if (this.notifications$.value && this.lastQueryParams$.value.page !== 1) {
            this.notifications$.next(this.notifications$.value.concat(response.results));
        }
        else {
            this.notifications$.next(response.results);
        }
    };
    /**
     * Read all unread notifications
     */
    NotificationsComponent.prototype.setReadNotifications = function (notifications) {
        var unreadNotifications = notifications.filter(function (item) { return !item.read; });
        if (unreadNotifications.length > 0) {
            this.notificationsService.readAll().subscribe();
        }
        // const requests: Observable<void>[] = this.getUnreadNotificationRequests(
        //   notifications
        // );
        // if (requests.length !== 0) {
        //   combineLatest(requests).subscribe();
        // }
    };
    /* private getUnreadNotificationRequests(notifications: Notification[]) {
       const requests: Observable<void>[] = [];
       notifications.forEach((notification: Notification) => {
         if (!notification.read) {
           requests.push(this.notificationsService.read(notification.id));
         }
       });
  
       return requests;
     }*/
    NotificationsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return NotificationsComponent;
}());
export { NotificationsComponent };
